import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { createUserSaga } from "src/store/users/saga";
import * as Yup from "yup";

const UserCreateForm = ({
  onHide,
  open,
  onSuccessClick,
}: {
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("Users.CreateFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          Name: "",
          Surname: "",
          Email: "",
          Password: "",
          ConfirmPassword: "",
          PhoneNumber: "",
        }}
        onSubmit={(values) => {
          dispatch(
            createUserSaga({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(t(message), {
                    theme: "colored",
                  });
                },
              },
              body: values,
            })
          );
        }}
        validationSchema={Yup.object().shape({
          Name: Yup.string().required(t("Validation.Required").toString()),
          Surname: Yup.string().required(t("Validation.Required").toString()),
          Email: Yup.string()
            .required(t("Validation.Required").toString())
            .email(t("Validation.Email").toString()),
          Password: Yup.string().required(t("Validation.Required").toString()),
          ConfirmPassword: Yup.string()
            .required(t("Validation.Required").toString())
            .oneOf(
              [Yup.ref("Password")],
              t("Validation.PasswordNoMatched").toString()
            ),
        })}
        inputs={[
          {
            field: "Name",
            label: t("Users.Name").toString(),
          },
          {
            field: "Surname",
            label: t("Users.Surname").toString(),
          },
          {
            field: "Email",
            label: t("Users.Email").toString(),
          },
          {
            field: "PhoneNumber",
            label: t("Users.PhoneNumber").toString(),
          },
          {
            field: "Password",
            type: "password",
            col: 6,
            label: t("Users.Password").toString(),
          },
          {
            field: "ConfirmPassword",
            type: "password",
            col: 6,
            label: t("Users.Password").toString(),
          },
        ]}
      />
    </React.Fragment>
  );
};
export default UserCreateForm;
